import {
    getPhotoData,
} from './utils';

const preloadedPhotoUrls =
    new Set();

const normalizePhotoIndex = (
    index,
    photoCount
) => {
    if (photoCount === 0) {
        return null;
    }

    if (index < 0) {
        return photoCount - 1;
    }

    if (index >= photoCount) {
        return 0;
    }

    return index;
};

export const preloadPhotoAtIndex = (
    triggers,
    index
) => {
    const normalizedIndex =
        normalizePhotoIndex(
            index,
            triggers.length
        );

    if (normalizedIndex === null) {
        return;
    }

    const trigger =
        triggers[normalizedIndex];

    if (!trigger) {
        return;
    }

    const photo =
        getPhotoData(trigger);

    if (
        !photo.url
        || preloadedPhotoUrls.has(
            photo.url
        )
    ) {
        return;
    }

    preloadedPhotoUrls.add(
        photo.url
    );

    const preloadImage =
        new Image();

    preloadImage.decoding =
        'async';

    preloadImage.src =
        photo.url;
};

export const preloadAdjacentPhotos = (
    triggers,
    currentIndex
) => {
    if (triggers.length < 2) {
        return;
    }

    preloadPhotoAtIndex(
        triggers,
        currentIndex - 1
    );

    preloadPhotoAtIndex(
        triggers,
        currentIndex + 1
    );
};

export const clearPreloadedPhotos = () => {
    preloadedPhotoUrls.clear();
};